'use client';

import { useEffect } from 'react';
import Link from 'next/link';
import Navbar from './Components/Header/navbar';
import './globals.css';

const siteName = process.env.NEXT_PUBLIC_SITE_NAME || 'TV Foco';

const htmlFontVars = {
	'--font-montserrat': "'Montserrat', ui-sans-serif, system-ui, sans-serif",
	'--font-ubuntu': "'Ubuntu', ui-sans-serif, system-ui, sans-serif",
};

export default function GlobalError({ error, reset }) {
	useEffect(() => {
		try {
			console.error('Global error:', error);
		} catch {}
	}, [error]);

	const handleReset = () => {
		try {
			reset();
		} catch {
			window.location.reload();
		}
	};

	return (
		<html lang="pt-BR" style={htmlFontVars}>
			<head>
				<link rel="preconnect" href="https://fonts.googleapis.com" />
				<link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="" />
				<link
					rel="stylesheet"
					href="https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700&family=Ubuntu:wght@400;700&display=swap"
				/>
			</head>
			<body>
				<Navbar />
				<main id="content" role="main">
					<div className="container contentStateWrap">
						<div className="contentStateCard contentStateCardError">
							<p className="contentStateEyebrow">Erro crítico</p>
							<h1>Algo saiu do esperado</h1>
							<p className="contentStateDesc">
								Não foi possível carregar a página. Tente novamente ou acesse a página inicial.
							</p>
							<div className="contentStateActions">
								<button type="button" className="contentStateBtn contentStateBtnPrimary" onClick={handleReset}>
									Tentar novamente
								</button>
								<Link href="/" className="contentStateBtn contentStateBtnOutline">
									Página inicial
								</Link>
							</div>
						</div>
					</div>
				</main>
				<footer id="footer">
					<div className="menufooter">
						<div className="container">
							<div className="menu-institucional-container">
								<ul id="menu-institucional" className="menus">
									<li className="menu-item nav-item">
										<a href="/" className="nav-link" title="Home">
											Home
										</a>
									</li>
									<li className="menu-item nav-item">
										<a href="/quem-somos/" className="nav-link" title="Quem Somos">
										Quem Somos
										</a>
									</li>
									<li className="menu-item nav-item">
										<a href="/expediente-e-equipe/" className="nav-link" title="Expediente e Equipe">
											Expediente e Equipe
										</a>
									</li>
									<li className="menu-item nav-item">
										<a href="/ultimas-noticias/" className="nav-link" title="Últimas Notícias">
											Últimas Notícias
										</a>
									</li>
									<li className="menu-item nav-item">
										<a href="/contato/" className="nav-link" title="Contato">
											Contato
										</a>
									</li>
									<li className="menu-item nav-item">
										<a href="/politica-de-privacidade/" className="nav-link" title="Política de Privacidade">
											Política de Privacidade
										</a>
									</li>
								</ul>
							</div>
						</div>
					</div>
					<div className="copyright">
						<div className="container">
							<p>
								Copyright © {new Date().getFullYear()} {siteName} — Todos os direitos reservados.
							</p>
						</div>
					</div>
				</footer>
			</body>
		</html>
	);
}
